import $ from 'jquery';

import ww from './globals';
import Swiper from 'swiper';

$(document).ready(function() {
  const $openClick = $('.open-full-article'),
    $content = $('.specific-article__content');

  $openClick.on('click', function() {
    $content.addClass('active');
  });

  //payment system
  $('.payment-button').on('click', function() {
    $('.full-article__background').hide();
    $('.full-article__payment').show();
  });

  //open slowly articles
  $.fn.onclick = function() {
    var functions = arguments;
    return this.click(function() {
      var iteration = $(this).data('iteration') || 0;
      functions[iteration].apply(this, arguments);
      iteration = (iteration + 1) % functions.length;
      $(this).data('iteration', iteration);
    });
  };

  $('figure img').on('click', e => {
    let $this = $(e.currentTarget);
    let imgAttr = $this.attr('src');

    if (ww > 756) {
      $.fancybox.open({
        src: imgAttr
      });
    } else {
      $.fancybox.open({
        clickContent: 'close',
        buttons: ['close'],
        src: imgAttr
      });
    }
  });

  if ($('.banner__carousel').length) {
    new Swiper('.banner__carousel', {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      slidesPerView: 1,
      spaceBetween: 5,
      autoplay: {
        delay: 3000
      }
    });
  }
});
